import TagItem from './components/module/tagitem'
import Star from './components/module/star'
import Textarea from './components/module/textarea'
import XkWaiter from './components/module/waiter'
import XkHintBox from './components/module/hintBox'
import XkAdd from './components/module/add'
import XkdetailsBox from './components/module/detailsBox'
import XkTabs from './components/module/tabs'
import XkcouponMod from './components/module/couponMod'
import XkRollBanner from './components/module/rollBanner'
import XkSiteInput from './components/module/siteInput'
import XkInput from './components/module/input'
import XkCircuitMod from './components/module/circuitMod'
import XkSideMenus from './components/module/sideMenus'
import XkTypeTabs from './components/module/typeTabs'
import XkModalMod from './components/module/modalMod'
import XkCarType from './components/module/carType'
import XkAlertBox from './components/module/alertBox'
import XKinputBox from './components/module/inputBox'
import XKdatePickerMod from './components/module/datePickerMod'
import XKCouponSelect from './components/module/couponSelect'
import XKRecordOrderMod from './components/module/recordOrderMod'
import XKUnfilledOrderMod from './components/module/unfilledOrderMod'
import XKuploadMod from './components/module/uploadMod'
import XkInformTimeMod from './components/module/informTimeMod'
import XkCouponNav from './components/module/couponNav'
import XkCapitalRecordList from './components/module/capitalRecordList'
import XkUpImgDom from './components/module/upImg'
import XkUpAvatar from './components/module/upAvatar'
import XkhomeBut from './components/module/homeBut'
import XKLineSelect from './components/module/lineSelect'
import XKnumberSelect from './components/module/numberSelect'
import XKnavTabs from './components/module/navTbas'
import XKinvoiceRecordMod from './components/module/invoiceRecordMod'
import XkbadgeMod from './components/module/badge'
import XKcarTypeScroll from './components/module/carTypeScroll'
import XKcheckInput from './components/module/checkInput'
import XKimgcode from './components/module/imgCode'

const install = function (Vue, opts = {}) {
  if (install.installed) return
  Vue.component(TagItem.name, TagItem)
  Vue.component(Star.name, Star)
  Vue.component(Textarea.name, Textarea)
  Vue.component(XkWaiter.name, XkWaiter)
  Vue.component(XkHintBox.name, XkHintBox)
  Vue.component(XkAdd.name, XkAdd)
  Vue.component(XkdetailsBox.name, XkdetailsBox)
  Vue.component(XkTabs.name, XkTabs)
  Vue.component(XkcouponMod.name, XkcouponMod)
  Vue.component(XkRollBanner.name, XkRollBanner)
  Vue.component(XkSiteInput.name, XkSiteInput)
  Vue.component(XkInput.name, XkInput)
  Vue.component(XkCircuitMod.name, XkCircuitMod)
  Vue.component(XkSideMenus.name, XkSideMenus)
  Vue.component(XkTypeTabs.name, XkTypeTabs)
  Vue.component(XkModalMod.name, XkModalMod)
  Vue.component(XkCarType.name, XkCarType)
  Vue.component(XkAlertBox.name, XkAlertBox)
  Vue.component(XKinputBox.name, XKinputBox)
  Vue.component(XKdatePickerMod.name, XKdatePickerMod)
  Vue.component(XKCouponSelect.name, XKCouponSelect)
  Vue.component(XKUnfilledOrderMod.name, XKUnfilledOrderMod)
  Vue.component(XKRecordOrderMod.name, XKRecordOrderMod)
  Vue.component(XKuploadMod.name, XKuploadMod)
  Vue.component(XkInformTimeMod.name, XkInformTimeMod)
  Vue.component(XkCouponNav.name, XkCouponNav)
  Vue.component(XkCapitalRecordList.name, XkCapitalRecordList)
  Vue.component(XkUpImgDom.name, XkUpImgDom)
  Vue.component(XkUpAvatar.name, XkUpAvatar)
  Vue.component(XkhomeBut.name, XkhomeBut)
  Vue.component(XKnumberSelect.name, XKnumberSelect)
  Vue.component(XKLineSelect.name, XKLineSelect)
  Vue.component(XKcheckInput.name, XKcheckInput)
  Vue.component(XkbadgeMod.name, XkbadgeMod)
  Vue.component(XKimgcode.name, XKimgcode)
  Vue.component(XKinvoiceRecordMod.name, XKinvoiceRecordMod)
  Vue.component(XKcarTypeScroll.name, XKcarTypeScroll)
  Vue.component(XKnavTabs.name, XKnavTabs)
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: '1.0.0',
  install,
  TagItem,
  Star,
  Textarea,
  XkWaiter,
  XkHintBox,
  XkAdd,
  XkdetailsBox,
  XkTabs,
  XkcouponMod,
  XkRollBanner,
  XkSiteInput,
  XkInput,
  XkSideMenus,
  XkTypeTabs,
  XkModalMod,
  XkCarType,
  XkAlertBox,
  XKinputBox,
  XKdatePickerMod,
  XKCouponSelect,
  XKRecordOrderMod,
  XKUnfilledOrderMod,
  XKuploadMod,
  XKimgcode,
  XkInformTimeMod,
  XkbadgeMod,
  XkCouponNav,
  XkCapitalRecordList,
  XkUpImgDom,
  XkhomeBut,
  XkUpAvatar,
  XKnumberSelect,
  XKLineSelect,
  XKcarTypeScroll,
  XKcheckInput,
  XKnavTabs,
  XKinvoiceRecordMod,
  XkCircuitMod
}



// WEBPACK FOOTER //
// ./src/xiaoka.js